<template>
  <!-- 开屏广告设置 -->
  <div>
    <SpCardContent :title="`开屏广告设置`">
      <el-form
        ref="form"
        :rules="ruleForm"
        :model="form"
        label-width="200px"
      >
        <el-form-item label="广告素材">
          <!-- <el-radio
            v-model="radio"
            :label="1"
          >
            图片
          </el-radio> -->
          <div>
            <div class="tips">
              <p>点击图片可更换，图片大小不能超过2M</p>
            </div>
            <div
              class="pics-box"
              @click="selectImage"
            >
              <div
                v-if="form.ad_material"
                class="goodspic"
              >
                <img :src="form.ad_material">
              </div>
              <div
                v-else
                class="upload-box"
              >
                <i class="el-icon-plus" />
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="是否开启">
          <el-radio
            v-model="form.is_enable"
            label="1"
          >
            开启
          </el-radio>
          <el-radio
            v-model="form.is_enable"
            label="0"
          >
            关闭
          </el-radio>
        </el-form-item>
        <el-form-item
          label="弹出间隔"
          prop="days_later_popup"
        >
          <el-input
            v-model.number="form.days_later_popup"
            placeholder="请输入天数"
            style="width: 220px"
          />
          天
        </el-form-item>
      </el-form>
    </SpCardContent>

    <SpGlobalFooter>
      <el-button
        type="primary"
        :loading="loading"
        @click="onSubmit"
      >
        保存设置
      </el-button>
    </SpGlobalFooter>

    <!-- 选择图片 -->
    <ImageSelect
      :image-visible="imageVisible"
      :choose-one="true"
      @closeImageDialog="closeImageDialog"
      @chooseImage="chooseImage"
    />
  </div>
</template>

<script>
import { getOpenScreenAd, saveOpenScreenAd } from '@/api/setting/openScreenAd'
import ImageSelect from '@/components/imageSelect'
export default {
  components: { ImageSelect },
  data () {
    var checkInput = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('弹出间隔不能为空或0'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('弹出间隔必须为数字值'))
        } else if (value < 0) {
          callback(new Error('弹出间隔必须大于0'))
        } else {
          callback()
        }
      }, 500)
    }
    return {
      loading: false,
      radio: 1,
      form: { is_enable: '', ad_material: '', days_later_popup: 0 },
      imageVisible: false,
      ruleForm: {
        //表单验证规则
        days_later_popup: [{ validator: checkInput, trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.getSetting()
  },
  methods: {
    // 获取设置
    async getSetting () {
      const data = await getOpenScreenAd()
      if (data && data.ad_material) {
        this.form.days_later_popup = +data.days_later_popup
        this.form = data
      }
    },

    // 保存设置
    onSubmit () {
      this.loading = true
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = await saveOpenScreenAd(this.form).catch(() => {
            this.loading = false
          })
          if (data) {
            this.loading = false
            this.$message({
              type: 'success',
              message: '保存成功'
            })
          }
        } else {
          this.$message.error('请先验证所填信息')
          this.loading = false
          return false
        }
      })
    },

    // 打开选择图片对话框
    selectImage () {
      this.imageVisible = true
    },
    // 关闭商品对话框
    closeImageDialog () {
      this.imageVisible = false
    },
    // 选择图片
    chooseImage (selectdata) {
      if (selectdata.length > 0) {
        let selectImageData = selectdata[0].image_url
        this.form.ad_material = selectImageData
        this.imageVisible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-top {
  margin-bottom: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-size: 28px;
  color: #606266;
}
.tips {
  font-size: 14px;
  color: #999999;
  line-height: 40px;
}

.pics-box {
  width: 146px;
  height: 146px;
}
.upload-box {
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  width: 144px;
  height: 144px;
  display: flex;
  justify-content: center;
  align-items: center;

  .el-icon-plus {
    font-size: 24px;
  }

  &:hover {
    border-color: #409eff;
  }
}
.goodspic {
  width: 146px;
  height: 146px;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.custom_alert {
  margin-bottom: 20px;
}
</style>
